import styled from "styled-components";
import {
	Space,
	Button as AntButton,
	Form as AntForm,
	Input as AntInput,
} from "antd";
import { IMG_WALLET_BG } from '@assets';

export const RootContainer = styled.div`
	padding: 16px;

	.ant-form {
		position: relative;
		margin-top: 22px;
	}

	.ant-input {
		padding-left: 20px;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		color: #181e1f;
	}

	.float-label label {
		color: #c21c05;
		font-size: 12px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
	}
`;

export const Title = styled.div`
padding-bottom: 8px;
font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #1E1E1E;
`;

export const InfoBox = styled(Space)`
	width: calc(100% - 32px);
	padding: 16px 16px 6px 16px;
	flex-direction: ${props => props.vertical === 1 ? 'column' : 'row'};
	gap: 6px !important;
	align-items: center;
	justify-content: flex-start;
	position: relative;

	border-radius: 16px;
	background: linear-gradient(180deg, #EE3530 0%, #DC211C 100%);
	box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10);

	.ant-space-item {
		display: flex;
	}
`;

export const Image = styled.img.attrs({
	alt: "icon",
})`
	width: 60px;
	border-radius: 16px;
	z-index: 100;
`;

export const AccountTypeText = styled.div`
font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 1.5;
	color: #fff;
	z-index: 100;
	position: relative;

	@media screen and (max-width: 320px) {
		font-size: 14px;
	}
`;

export const Text = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #1c1c1c;

	@media screen and (max-width: 345px) {
		font-size: 13px;
	}

	@media screen and (max-width: 320px) {
		font-size: 12px;
	}
`;

export const BoldText = styled.div`
	font-size: 16px;
	font-weight: bold;
	color: #71207c;
`;

export const GroupContainer = styled.div`
	margin: 16px 0;

	@media screen and (max-width: 325px) {
		.ant-col {
			padding-left: 3px !important;
			padding-right: 3px !important;
		}
	}
`;

export const Item = styled.div`
	padding: 0 12px;
	height: 36px;
	border-radius: 15px;
	background: ${(props) => (props.selected === "true" ? "linear-gradient(180deg, #00DE00 0%, #008500 100%)" : "transparent")};
	border: ${(props) => (props.selected === "true" ? "none" : "1px solid #004E00")};
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;

	${Text} {
		text-align: center;
		flex: 1;
		color: ${(props) => (props.selected === "true" ? "#fff" : "#1c1c1c")};
	}

	@media screen and (max-width: 375px) {
		padding: 0 8px;

		${Text} {
			font-size: 12px;
		}
	}

	@media screen and (max-width: 325px) {
		padding: 0 8px;

		${Text} {
			font-size: 10px;
		}
	}
`;

export const HelperText = styled.div`
	padding-top: 6px;
	padding-left: 20px;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #5D5189;

	@media screen and (max-width: 345px) {
		font-size: 10px;
	}

	@media screen and (max-width: 320px) {
		font-size: 10px;
	}
`;

export const ButtonWrapper = styled.div`
	text-align: center;

	.ant-btn {
		height: 56px;
		border-radius: 16px;
		margin-top: 0px;
	}
`;

export const Box = styled(Space).attrs({
	size: "middle",
})`
	margin-right: -36px;
	align-items: center;

	.anticon {
		font-size: 20px;
		cursor: pointer;
	}
`;

export const ContinueButton = styled(AntButton)`
width: 100%;
height: 56px !important;
	font-size: 16px !important;
	border-radius: 16px;
	border: 2px solid var(--Btn-Stroke, #DC211C);
	background: var(--Btn-Background, linear-gradient(180deg, #EE3530 0%, #DC211C 100%));
	box-shadow: 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;
`;

export const Form = styled(AntForm)`
	width: 100%;

	.ant-form-item {
		margin-bottom: 32px;
	}

	.ant-form-item-required {
		padding-left: 10px;
		color: #9f9fa2 !important;
	}

	.ant-form-item-label label {
		color: #5D5189 !important;
		font-size: 12px !important;
		font-weight: 400 !important;
		line-height: 1.5 !important;
		display: flex !important;
		margin-left: 18px I !important;
	}

	input:not(.ant-input-status-error) {
		border: none !important;
		box-shadow: none !important;
		
		:hover,
		:focus {
			border: none !important;
			box-shadow: none !important;
		}
	}
	
	input {
		font-weight: 500 !important;
		font-size: 16px !important;
		border-radius: 8px;
		background: #E5E0F5 !important;
		color: #000 !important;
		padding-left: 16px !important;
		
		::placeholder {
			color: #424242;
		}
	}

	input[type="text"],
	input[type="number"] {
		height: 52px;
	}

	input[type="password"] {
		height: 40px;
	}
`;

export const Input = styled(AntInput)`
	-moz-appearance: textfield;
	appearance: textfield;
	::-webkit-inner-spin-button,
	::-webkit-outer-spin-button {
		-webkit-appearance: none; /* WebKit */
		margin: 0;
	}
	::-webkit-inner-spin-button:disabled,
	::-webkit-outer-spin-button:disabled {
		display: none;
	}
`;


export const Background = styled.img.attrs({
	alt: 'bg',
	src: IMG_WALLET_BG,
  })`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
`;